import { render, staticRenderFns } from "./PerformanceList.vue?vue&type=template&id=0fe41874&scoped=true"
import script from "./PerformanceList.vue?vue&type=script&lang=js"
export * from "./PerformanceList.vue?vue&type=script&lang=js"
import style0 from "./PerformanceList.vue?vue&type=style&index=0&id=0fe41874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe41874",
  null
  
)

export default component.exports